import type { GameObject, ObjectState } from "./types.ts";
// An image layer can have named states, each with its own picture. Rules
// switch states by name, so «ранен» works the same on every character.
export const stateKey = (name: string) => name.trim().toLocaleLowerCase("ru");
export function currentState(o: GameObject): ObjectState | null {
  return (o.state && o.states?.find((s) => s.id === o.state)) || null;
}
export function findState(o: GameObject, name: string) {
  const key = stateKey(name);
  return o.states?.find((s) => stateKey(s.name) === key) || null;
}
/** Picture shown for a layer: its state's, its own, then its entity's. */
export function imageOf(
  o: GameObject,
  entities: { id: string; imageId: string | null }[],
) {
  return (
    currentState(o)?.imageId ||
    o.imageId ||
    entities.find((e) => e.id === o.entityId)?.imageId ||
    null
  );
}
